// hooks/use-success-notification.tsx
import { createContext, useContext, useState, ReactNode } from "react";

interface NotificationState {
  title: string;
  message: string;
  show: boolean;
}

interface SuccessNotificationContextType {
  notify: (title: string, message: string) => void;
  state: NotificationState;
  hide: () => void;
}

const SuccessNotificationContext = createContext<SuccessNotificationContextType | undefined>(undefined);

export const SuccessNotificationProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<NotificationState>({
    title: "",
    message: "",
    show: false,
  });

  const notify = (title: string, message: string) => {
    setState({ title, message, show: true });
  };

  const hide = () => setState((s) => ({ ...s, show: false }));

  return (
    <SuccessNotificationContext.Provider value={{ notify, state, hide }}>
      {children}
    </SuccessNotificationContext.Provider>
  );
};

export const useSuccessNotification = () => {
  const context = useContext(SuccessNotificationContext);
  if (!context) throw new Error("useSuccessNotification must be used within SuccessNotificationProvider");
  return context;
};
